import { Box, Button, Card, Grid, newToast, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { Application, StudentServiceTemplate } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const ApplicationQrCodes = (props: {
  application: Application;
  setApplication: (value: Application) => void;
}) => {
  const dispatch = useDispatch();
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  const generateQrCode = () => {
    ApiService.applications.generateQrCode(props.application.id).then((response) => {
      props.setApplication(
        produce(props.application, (draft) => {
          draft.qrCodeUploadFile = response;
        })
      );
      dispatch(setAppToast(newToast("success", "QR Code generated and saved successfully.")));
      window.location.reload();
    });
  };

  const renderNewQrCode = () => {
    return props.application.qrCodeUploadFile ? (
      <FilePanel
        fileName={props.application.qrCodeUploadFile?.fileName}
        fileSize={props.application.qrCodeUploadFile?.fileSize}
        fileRef={props.application.qrCodeUploadFile?.fileRef}
        imagePreviewData={props.application.qrCodeUploadFile?.imagePreviewData}
      />
    ) : (
      <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <Button variant="contained" onClick={generateQrCode}>
          Generate QR Code
        </Button>
      </Box>
    );
  };

  return (
    <Box ref={breakpointsRef}>
      <Grid container spacing="lg">
        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })}>
          <Card header="QR Code" fullHeight>
            {renderNewQrCode()}
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
